import React from 'react';

export interface LibraryProviderProps {
  className?: string;
  children: React.ReactNode;
}

export const LibraryProvider: React.FC<LibraryProviderProps> = ({
  className,
  children,
}) => {
  return (
    <div className={['ra-scope', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
};
